import { AutoDisplayCondition } from '../types/templates'
import { getDateString } from '../utils/dates'

export const electronicConsentHeader = 'Electronic Consent'
export const electronicConsentPreface =
  'The following consent forms and agreements must be signed in order to officially sign on for care. To proceed electronically, the following must be agreed to and acknowledged by you as the patient:'

export const getElectronicConsentFormHeader = (signedOn: string) =>
  `You signed this agreement on ${getDateString(signedOn)}. If you have any questions or concerns, please contact us via our website at https://hamiltonbilling.com or send an email to info@hamiltonbilling.com.`

export const electronicConsentCheckbox1 =
  'I agree to both access and sign consent forms and/or agreements electronically in order to proceed.'

export const electronicConsentCheckbox2 =
  'In order to obtain a copy of my signed consent forms or agreements for my personal records, I agree to download in lieu of receiving a paper copy from Hamilton Billing. I understand I can access these files by logging into HamiltonBilling.com under ‘My Account’ at any point during the duration of my care.'

export const electronicConsentCheckbox3 =
  'If at any point I wish to withdraw consent in receiving documents electronically, I will email info@hamiltonbilling.com informing Hamilton Billing informing them as such, or alternatively, inform my provider, asking them to reach out separately to Hamilton Billing.'

export const electronicConsentCheckbox4 =
  'I understand that if I want a paper copy of my signed consent forms or agreements sent to me by Hamilton Billing, I must make this request by sending an email to info@hamiltonbilling.com, indicating where I would like copies mailed. I will also make myself available to outreach by Hamilton Billing if they have additional questions before mailing. In making this request, I understand a processing fee of $50 will apply in order to receive paper copies mailed to my address, and that I must give Hamilton Billing up to 30 calendar days to send me a copy once they have responded to my inquiry. Alternatively, I can request documents be emailed to me at no charge, which I must also give Hamilton Billing up to 30 calendar days to send.'

export const electronicConsentCheckboxes = [
  electronicConsentCheckbox1,
  electronicConsentCheckbox2,
  electronicConsentCheckbox3,
  electronicConsentCheckbox4,
]

export const autoDisplayConditionText: Record<AutoDisplayCondition['type'], string> = {
  all: 'All patients',
  medicaid: 'Medicaid patients',
  'non-medicaid': 'Non-Medicaid patients',
  'self-pay': 'Self-pay patients',
  insurer: 'Patients with this insurer:',
  'insurance-plan': 'Patients with this insurance plan:',
  'delivery-location': 'Patients with this delivery location:',
}
